import { IPeriodReport, IZReport } from "@prostocheck/shared";

const sum = (values: number[]): number =>
  Number(values.reduce((total, value) => total + value, 0).toFixed(2));

/**
 * Sums the Z-reports of a period into one picture — the report a business
 * actually needs at the end of a week, and the one the tax cabinet does not
 * offer. Pure: the reports are fetched by the caller.
 */
export const buildPeriodReport = ({
  cashRegisterFn,
  from,
  to,
  reports,
}: {
  cashRegisterFn: string;
  from: string;
  to: string;
  reports: IZReport[];
}): IPeriodReport => {
  // Newest day first — that is how the period report reads best, and how the
  // modal shows it (`PeriodDays`).
  const days = [...new Set(reports.map(report => report.closedAt.slice(0, 10)))]
    .sort()
    .reverse()
    .map(date => {
      const ofDay = reports.filter(
        report => report.closedAt.slice(0, 10) === date,
      );

      return {
        date,
        salesTotal: sum(ofDay.map(report => report.salesTotal)),
        returnsTotal: sum(ofDay.map(report => report.returnsTotal)),
        receiptsCount: sum(
          ofDay.map(report => report.salesCount + report.returnsCount),
        ),
      };
    });

  const salesTotal = sum(reports.map(report => report.salesTotal));
  const returnsTotal = sum(reports.map(report => report.returnsTotal));

  return {
    cashRegisterFn,
    from,
    to,
    shiftsCount: reports.length,
    salesTotal,
    returnsTotal,
    netTotal: Number((salesTotal - returnsTotal).toFixed(2)),
    receiptsCount: sum(
      reports.map(report => report.salesCount + report.returnsCount),
    ),
    payments: {
      cash: sum(reports.map(report => report.payments.cash)),
      card: sum(reports.map(report => report.payments.card)),
    },
    days,
  };
};
